import { cloneDeep } from 'lodash';
import { deleteNestedProperty } from './delete-properties.util';
import {
  redactObjectValues,
  type RedactReturnType,
  type RedactReturnTypeStr,
} from './redact-values.util';

export const scrubObjectKeys = [
  'firstName',
  'lastName',
  'password',
  'ssn',
  'cpr',
];

/**
 * Fully scrubs object for confidential information.
 * @param obj
 * @param returnType      Used for determining if output is object or result.
 * @returns
 */
export const scrubObject = <T extends object, R extends RedactReturnTypeStr>(
  obj: T,
  returnType: R,
): RedactReturnType<T, R> => {
  if (!obj) return null;
  //Errors are weird and cannot be cloned or mutated.
  if (obj instanceof Error)
    return (returnType === 'string' ? obj?.stack : obj) as RedactReturnType<
      T,
      R
    >;

  //Copy object to avoid mutations of object that is being used in other code.
  const clonedObject = cloneDeep(obj);

  // Scrub event for any properties that are sensitive
  const scrubbedEventChildren = deleteNestedProperty(
    clonedObject,
    new Set(scrubObjectKeys),
  );

  // Scrub event for any strings that are sensitive
  const scrubbedEvent = redactObjectValues(scrubbedEventChildren, returnType, {
    jsonTextKeys: scrubObjectKeys,
  });

  return scrubbedEvent;
};
